module.exports = __webpack_public_path__ + "static/media/details-28-image-3.314861fe.jpg";